import { css } from '@emotion/react'
import { HFlow, Spinner, Text, Theme, useTheme, VFlow } from 'bold-ui'

import { HeaderPainelChamada } from './components/HeaderPainelChamada'
import { PainelChamadasErrorView } from './components/PainelChamadasErrorView'
import { usePainelPareamento } from './hooks/usePainelPareamento'

interface PainelPareamentoViewProps {
  onPareado(tokenAcesso: string, uuidDispositivo: string): void
}

export function PainelPareamentoView(props: Readonly<PainelPareamentoViewProps>) {
  const { onPareado } = props
  const theme = useTheme()
  const { pinUsuario, isGenerating, hasFatalError, isUnauthorizedUser } = usePainelPareamento(onPareado)

  const styles = createStyles(theme)

  const caracteres = pinUsuario ? pinUsuario.split('') : []

  if (isUnauthorizedUser) {
    return (
      <PainelChamadasErrorView
        title='Conflito entre sessões'
        description='A mesma sessão não pode ser compartilhada entre um usuário logado e o painel de chamadas. Para configurar um painel é necessário efetuar o logout.'
      />
    )
  }

  if (hasFatalError) {
    return (
      <PainelChamadasErrorView title='Ocorreu um erro inesperado.' description='Atualize a página e tente novamente.' />
    )
  }

  return (
    <VFlow style={styles.wrapper}>
      <HeaderPainelChamada variant='dark' />
      <div css={styles.contentArea}>
        {isGenerating || !pinUsuario ? (
          <VFlow vSpacing={2} style={styles.textAlignCenter}>
            <Text variant='h1' color='inherit'>
              Carregando configurações do painel de chamadas
            </Text>
            <Spinner size={3} />
          </VFlow>
        ) : (
          <VFlow vSpacing={3} style={styles.textAlignCenter}>
            <VFlow vSpacing={1}>
              <Text variant='h1' color='inherit'>
                Conectar painel de chamadas
              </Text>
              <Text color='inherit' variant='h3' fontWeight='normal'>
                Para autorizar esse dispositivo a utilizar o painel de chamadas, acesse a aba "Painel de chamadas" nas
                <br />
                configurações da sua unidade de saúde e adicione esse dispositivo, incluindo o código abaixo.
              </Text>
            </VFlow>

            <HFlow hSpacing={1.5} justifyContent='center'>
              {caracteres.map((caractere, index) => (
                <div key={`${caractere}-${index}`} css={styles.pinBox}>
                  <Text color='inherit' style={styles.pinText}>
                    {caractere}
                  </Text>
                </div>
              ))}
            </HFlow>
          </VFlow>
        )}
      </div>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => {
  return {
    wrapper: css`
      flex: 1;
      background-color: ${theme.pallete.primary.c30};
      color: ${theme.pallete.gray.c100};
      padding: 2rem 2.5rem 2.625rem;
    `,
    contentArea: css`
      margin-top: 5rem;
    `,
    textAlignCenter: css`
      text-align: center;
    `,
    pinBox: css`
      border: 3px solid ${theme.pallete.gray.c100};
      border-radius: 12px;
      padding: 0.75rem 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    pinText: css`
      font-size: 6rem;
      font-weight: bold;
      line-height: 1;
    `,
  }
}
